module.exports = __webpack_public_path__ + "img/bmcl_gallery16.0379b7f4.jpg";